import React from "react";
import NetworkStatusIndicator from "components/common/NetworkStatusIndicator";
import ClickToCopyWrapper from "components/common/ClickToCopyWrapper";
import SimpleTooltip from "components/common/SimpleTooltip";
import { FiExternalLink } from "react-icons/fi";
import { GAM_CONSOLE_URL } from "constants/GAMUrl";

class NetworkTextDisplay extends React.Component {
  render() {
    const {
      network,
      hideIndicator = false,
      hideId = false,
      viewYieldSet = false,
      place = "top",
    } = this.props;

    return (
      <div className="flex items-center gap-1" key={network.networkId}>
        {!hideIndicator && (
          <NetworkStatusIndicator
            status={network.status}
          ></NetworkStatusIndicator>
        )}
        {!hideId && <span>{network.networkId}</span>}
        {viewYieldSet ? (
          <SimpleTooltip tooltipText="View Yield Sets" place={place}>
            <div
              className="cursor-pointer font-medium hover:text-blue-700"
              onClick={() => {
                window.open(
                  `${window.location.origin}/#/ops-mgmt/account/network/${network.networkId}/yield-sets`
                );
              }}
            >
              {network.name}
            </div>
          </SimpleTooltip>
        ) : (
          <div className="font-medium">{network.name}</div>
        )}

        <ClickToCopyWrapper
          copyText={`${GAM_CONSOLE_URL}/${network.code}`}
          tooltipMessage="Copy GAM console link"
          place={place}
          isTextBlue={true}
        ></ClickToCopyWrapper>
      </div>
    );
  }
}
export default NetworkTextDisplay;
